import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';

const PaymentWarnings = ({ isPastDue, isSoonDue }) => {
	return (
		<>
			{isPastDue && <Popup trigger={<Icon name='warning sign' color='red' />} content='Past Due' />}
			{isSoonDue && <Popup trigger={<Icon name='warning sign' color='yellow' />} content='Due Soon' />}
		</>
	);
};

export default PaymentWarnings;
